<div class="dwcData_1">
  <h3 class="headertesttext">
    Step Number - {{ dwcdata.stepNumber }}
  </h3>
  <h3 class="headertesttext" *ngIf="dwcdata.formType">
    {{ formTypeName }}
  </h3>
  <dl class="list">
    <ng-container class="list-item" *ngFor="let f of fieldsAre; let i = index">
      <dt class="slip-label">{{ f.label }}</dt>
      <dd class="slip-detail-value">
        {{ getValue(f.name) }}
      </dd>
    </ng-container>
  </dl>
</div>
